// extracted by mini-css-extract-plugin
module.exports = {"ShinyPlayer":"_1l9Io","shinyPlayer":"_1l9Io","icon":"_11oMk","pausing":"_1d1q9","playing":"_1ZXI6","mediaButton":"_3dzYM"};